import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseMarkNotificationAsRead {
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useMarkNotificationAsRead = ({ onSuccess, onError }: UseMarkNotificationAsRead) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['markNotificationAsRead'],
    mutationFn: async (data: { recipient_messages: Array<{ id: string }> }) => {
      await privateAxios.put('/notifications/recipient_messages/mark_as_read', {
        recipient_messages: data.recipient_messages,
      })
    },
    onSuccess,
    onError,
  })
}
